import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const FacebookIconSvg = () => (
  <svg width="1em" height="1em" viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.82632 13.7461H4.49156V7.05097H6.35723L6.55446 4.81216H4.49689V3.53285C4.49689 2.9998 4.6035 2.79724 5.11523 2.79724H6.55979V0.473145H4.71011C2.72184 0.473145 1.82632 1.34734 1.82632 3.02645V4.81216H0.435059V7.07762H1.82632V13.7461Z"
      fill="currentColor"
    />
  </svg>
);

export const FacebookIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={FacebookIconSvg} {...props} />
);
